<template>
  <dropdown-element :value="value" class="input-like" :class="{[dropdownClass]:true,'input-like-focus':isOpen}" :inputIconClass="inputIconClass" @isOpen="isOpen=$event;$event?loadRows():'void'">
    <div style="padding: 15px" @click="$event.stopPropagation()" v-if="!hideSearch">
        <slot name="menuTable">
          <div class="ui icon input">
            <i class="search icon"></i>
            <input type="text" placeholder="Search..." :value="search" @input="search=$event.target.value">
          </div>
          <dropdown-element class="ui dropdown" style="margin-left: 15px" inputIconClass="dropdown icon" :options="[10,20,50,100]" :value="size" @input="size=$event"></dropdown-element>
          <div class="ui input"><input style="width:70px;text-align: center; border:none; padding-left: 0px" type="number" min="1" :value="page+1" @input="page=$event.target.value-1"></div>
        </slot>
    </div>
    <control-table style="margin: 0px" colStyle="padding-left:15px;padding-right:15px;cursor:pointer" :showHeader="showHeader" :rows="rows" :columns="columns" :selectedRows="selectedRows" @rowClicked="handleRowClicked($event)"></control-table>
  </dropdown-element>
</template>

<script>
  import Vue from 'vue'
  import {merge,isEqual,isArray,debounce} from 'lodash'

  export default {
    name: "dropdown-http-control",
    props:{
      hideSearch:{
        type:Boolean,
        default:false
      },
      value:{

      },
      url:{
        type:String,
        required:true,
      },
      showHeader:{
        type:Boolean,
        default:false
      },
      dropdownClass:{
        type:String,
        default:'ui fluid dropdown'
      },
      inputIconClass:{
        type:String,
        default:'dropdown icon'
      },
      method:{
        type:String,
        default:"GET"
      },
      hardParams:{
        type:Object,
        default:()=>{return {}}
      },
      columns:{
        type:Array,
        default:()=>[Vue.$jsonSchemeUtils.tipicalLabelColumn('label','Label',{},true)]
      }
    },
    data(){
      return {
        rows:[],
        search:'',
        size:10,
        page:0,
        isOpen:false
      }
    },
    computed:{
      selectedRows(){return [].concat(this.value).filter(v=>v)},//для реактивности
      httpParams(){return merge({page:this.page,size:this.size,search:'label='+this.search},this.hardParams)}
    },
    methods:{
      loadRows(){
        return Vue.axios({
          method: this.method,
          url: this.url,
          params:this.httpParams
        }).then(responce=>responce.data).then(loadedData=>this.rows=loadedData.content || loadedData)
      },
      //loadRowsDebounce:debounce(this.loadRows,1000),//TODO сделать рабочим
      handleRowClicked(row){
        isArray(this.value)
          ?this.value.some(v=>isEqual(v,row))
            ?this.$emit('input',this.value.filter(v=>!isEqual(v,row)))
            :this.$emit('input',this.value.concat(row))
          :this.$emit('input',row)

      }
    },
    watch:{
      httpParams(){this.loadRows()}
    }

  }
</script>

<style scoped>
  .input-like{
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 0.28571429rem;
    padding: 0.67857143em 1em;
    line-height: 1.21428571em;
  }
  .input-like-focus{
    border-color: #85B7D9;
  }
</style>
